module.exports = __webpack_public_path__ + "static/media/polymer.4c572d99.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/polymer.png
// module id = 168
// module chunks = 0